/*
 * Needs the following scope variables to be defined in the main controller:
 * - modelName
 * - list
 * - listOptions
 * - maxRanges
 * - fields
 * - filters
 * */
angular
    .module('app.ocom')
    .directive('ocomTable', ['$state', '$injector', ocomTable])
    .directive('ocomForm', ['$state', '$injector', ocomForm])

function ocomTable($state, $injector) {
    return {
        restrict: 'EA',
        transclude: {
            'filter': '?filter',
            'filterRight': '?filterRight',
            'toolbar': '?toolbar',
            'table': 'table'
        },
        templateUrl: 'js/ocom/widgets/ocom-table.html',
        link: function (scope, elem, attrs) {
            scope.hideNewButton = scope.$eval(attrs.hideNewButton) || false;
            scope.destination = attrs.destination || "";
            scope.create_state = attrs.createState;

        },
        controller: function ($scope, $sessionStorage, stateStorage) {
            //Variable declarations
            var permissionService = null;

            //Scope functions
            $scope.refreshList = refreshList;
            $scope.changeOptionAndRefresh = changeOptionAndRefresh;
            $scope.changeLimit = changeLimit;
            $scope.selectPage = selectPage;
            $scope.pageChanged = pageChanged;
            $scope.updateFilter = updateFilter;
            $scope.canRead = canRead;
            $scope.canUpdate = canUpdate;
            $scope.setDateFromPickerField = setDateFromPickerField;
            $scope.setDateOnlyFromPickerField = setDateOnlyFromPickerField;

            //Watch functions
            $scope.$watch('listOptions', watchListOptions);

            function watchListOptions(list) {
                if ($scope.listOptions.searchField === '') {
                    // we force setting this to null so we can remove the empty dropdown option
                    $scope.listOptions.searchField = null;
                }
                if (angular.isDefined($scope.altFilters) && $scope.altFilters.length && angular.isDefined(list)) {
                    var filter = _.find($scope.altFilters, function (item) {
                        // noinspection JSUnresolvedVariable
                        return item.id.toString() === list.filter;
                    });
                    if (filter) {
                        $scope.backgroundColour = filter.backgroundColour;
                        $scope.foregroundColour = filter.foregroundColour;
                    } else {
                        $scope.backgroundColour = '#dddddd';
                        $scope.foregroundColour = '#000000';
                    }
                } else {
                    $scope.backgroundColour = '#fff';
                    $scope.foregroundColour = '#000';
                }
            }

            function refreshList(except) {
                var options = angular.copy($scope.listOptions);
                var destination = ($scope.destination) ? $scope.destination : $scope.modelName + ".list";
                // noinspection JSUnresolvedVariable
                var finalExcept = angular.isDefined(except) ?
                    angular.copy(except) : (angular.isDefined($scope.exceptSearch) ? $scope.exceptSearch : []);

                finalExcept = _.union(finalExcept, ['total', 'currentPage']);
                for (var i = 0; i < finalExcept.length; i++) {
                    delete options[finalExcept[i]];
                }
                stateStorage.storeStateThenGo(destination, options, true);
            }

            function changeOptionAndRefresh(field, value) {
                $scope.listOptions[field] = value;
                $scope.refreshList(); // Update When changed.
            }

            function changeLimit(limit) {
                $scope.listOptions.offset = 0;
                $scope.changeOptionAndRefresh("limit", limit);
            }

            function selectPage(page) {
                $scope.changeOptionAndRefresh("offset", $scope.listOptions.limit * (page - 1));
            }

            function pageChanged() {
                $scope.selectPage($scope.listOptions.currentPage);
            }

            function getPermissionService() {
                if (permissionService == null) {
                    if ($injector.has('permissionService')) {
                        permissionService = $injector.get('permissionService');
                    }
                }

                return permissionService;
            }

            function updateFilter() {
                var filter = _.find($scope.filters, function (filter) {
                    return filter.id === $scope.listOptions.filter;
                });

                if (filter) { // If there are OTHER fields in the filter - assign them
                    var otherParms = angular.copy(filter);
                    delete otherParms.id;
                    delete otherParms.name;

                    $scope.listOptions["offset"] = "0";

                        if (!_.isEmpty(otherParms)) {
                            _.assign($scope.listOptions, otherParms);
                        }
                    }

                $scope.refreshList(); // Update When changed.
            }

            function canRead(modelName, fieldName) {
                var permService = getPermissionService();

                if (permService != null) { // found it and can use it
                    return permService.has_permission($state.current.name, modelName, fieldName, "READ");
                }

                return true;
            }

            function canUpdate(modelName, fieldName) {
                var permService = getPermissionService();

                if (permService != null) { // found it and can use it
                    return permService.has_permission($state.current.name, modelName, fieldName, "UPDATE");
                }

                return true;
            }

            function setDateFromPickerField(field) {
                if ($scope.listOptions[field] !== null) {
                    $scope.listOptions[field] = moment($scope.listOptions[field]).format();
                }
                else {
                    $scope.listOptions[field] = null; // set to null
                }
                $scope.refreshList();
            }

            function setDateOnlyFromPickerField(field) {
                if ($scope.listOptions[field] !== null) {
                    // %Y-%m-%d
                    $scope.listOptions[field] = moment($scope.listOptions[field]).format('YYYY-MM-DD');
                }
                else {
                    $scope.listOptions[field] = null; // set to null
                }
                $scope.refreshList();
            }
        }
    };
}


function ocomForm($state, $injector) {
    return {
        restrict: 'EA',
        controller: function ($scope, $sessionStorage, stateStorage) {
            //Variable declarations
            var permissionService = null;

            //Scope functions
            $scope.canRead = canRead;
            $scope.canUpdate = canUpdate;

            function getPermissionService() {
                if (permissionService == null) {
                    if ($injector.has('permissionService')) {
                        permissionService = $injector.get('permissionService');
                    }
                }

                return permissionService;
            }

            function canRead(modelName, fieldName) {
                var permService = getPermissionService();

                if (permService != null) { // found it and can use it
                    return permService.has_permission($state.current.name, modelName, fieldName, "READ");
                }

                return true;
            }

            function canUpdate(modelName, fieldName) {
                var permService = getPermissionService();

                if (permService != null) { // found it and can use it
                    return permService.has_permission($state.current.name, modelName, fieldName, "UPDATE");
                }

                return true;
            }
        }
    }
}
